import type dayjs from 'dayjs';
import cloneDeep from 'lodash/cloneDeep';

import type { QuestionType } from '@webapp/common/resources/survey';

import { SurveyLimit } from '../profile';

import type { Addons } from './addons/addons';
import { initialAddons } from './addons/addons';

// TODO type other keys

export enum SurveyStatus {
    CREATED = 1,
    INWORK = 2,
    DELETED = 3,
    CLOSED = 4,
    COMPLETED = 5,
}

export interface IndividualPasswordResponse {
    ID: number;
    PASSWORD: string;
    USED: boolean;
}

export interface IndividualPassword {
    id: number;
    value: string;
    used: boolean;
}

export interface Survey {
    id: number;

    limits: SurveyLimit;
    lowLimit: SurveyLimit;

    folderId: number;

    fetch: boolean;
    expandSettings: boolean;
    hidden: boolean;

    status: SurveyStatus;
    enabled: boolean; // SurveyStatus.INWORK

    name: string;
    title: string;
    userName: string;
    subdomain: string;
    subdomainError?: boolean;

    password: string;

    creatorEmail: string;
    creatorName: string;
    startDatetime: string | dayjs.Dayjs;
    endDatetime: string | dayjs.Dayjs;
    createdDatetime: string;
    proExpDatetime: string;

    isPro: boolean;
    responseCount: number;
    timeCount: number; // average response time

    promocodes: Array<string>;
    promocodesLoaded?: boolean;
    individualPasswords: Array<IndividualPassword>;
    addons: Addons;

    logoStyle: string;
    titleStyle: string;

    questionTypes: Set<QuestionType>;

    hideFooter: boolean;

    order: number; // TODO ?? check, purge
    totalFileSize: number;
    totalFileCount: number;

    totalAudioSize: number;
    totalAudioCount: number;

    defaultLang?: string;
    multiLang?: string;
}

export const initialSurvey: Readonly<Survey> = {
    limits: SurveyLimit.None,
    lowLimit: SurveyLimit.None,

    logoStyle: '',
    titleStyle: '',
    userName: '',
    creatorEmail: '',
    creatorName: '',

    fetch: false,
    hidden: false, // used to hide in folders
    expandSettings: false,

    folderId: null,
    id: null,
    status: SurveyStatus.CLOSED,
    enabled: false,

    name: '',
    title: '',
    subdomain: '',
    password: '1234567',

    startDatetime: '',
    endDatetime: '',
    createdDatetime: '',
    proExpDatetime: '',

    isPro: false,
    responseCount: 0,
    timeCount: 0,

    promocodes: [],

    individualPasswords: [],
    addons: cloneDeep(initialAddons),

    questionTypes: new Set(),

    hideFooter: false,

    order: 0,

    totalFileSize: 0,
    totalFileCount: 0,

    totalAudioSize: 0,
    totalAudioCount: 0,
};
